import React from "react";
import { connect } from "react-redux";
import DynamicForm from "../../../components/dynamicscreens/DynamicForm";
import { CountryJson } from "../../../DynamicFormsJson/MastersJSON/country";
class CountryForm extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <>
                <DynamicForm
                    formPath={CountryJson.formPath}
                    screenTitle={CountryJson.screenTitle}
                    fieldMeta={CountryJson.fieldMeta}
                    tableColumnsToFilter={CountryJson.tableColumnsToFilter}
                    apiBaseURL={CountryJson.apiBaseURL}
                    baseIdColumn={CountryJson.baseIdColumn}
                    type={0}
                    isLog={true}
                />
            </>
        );
    }
}
const mapStateToProps = (state) => ({
});
const mapDispatchToProps = {
};
export default connect(mapStateToProps, mapDispatchToProps)(CountryForm);
